import React from 'react'
import { InfoSheet, useInfoSheet } from '@fs/zion-ui'
import { ControlSettingsAdjust } from '@fs/zion-icon'
import { useQueryParams } from '@fs/zion-router'
import { HeaderIconButton } from '../../../shared/components'
import DynamicLinksOverrideForm from './OverrideForm'

export default function DynamicLinksOverride() {
  const infoSheet = useInfoSheet()
  const { query } = useQueryParams()

  if (typeof query.override === 'undefined') {
    return null
  }

  return (
    <>
      <HeaderIconButton
        title="Header Links Override"
        data-test-id="hdr_info_sheet_button"
        Icon={ControlSettingsAdjust}
        onClick={infoSheet.handleClick}
      />
      <InfoSheet {...infoSheet} title="Header Links Override" size="lg">
        <DynamicLinksOverrideForm />
      </InfoSheet>
    </>
  )
}
